import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Terms.css';

const RefundPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            <div className="terms-container">
                <div className="terms-header">
                    <h1>환불 및 반품 정책</h1>
                    <button className="back-button" onClick={() => navigate(-1)}>
                        뒤로가기
                    </button>
                </div>
                
                <div className="terms-content">
                    <div className="terms-section">
                        <h2>패키지 제품 구성</h2>
                        <p>본 상품은 아래 구성품이 포함된 패키지 제품입니다.</p>
                        
                        <h3>1) 가족안심 패키지</h3>
                        <ul>
                            <li>당사 개발 건강관리 소프트웨어(이하 "스마트건강코치앱-SW")</li>
                            <li>태블릿 단말기/혈압계/혈당계/체중계 (외부 제조사 제품)</li>
                            <li>건강관리센터 웹</li>
                        </ul>
                        
                        <h3>2) 자가관리 패키지</h3>
                        <ul>
                            <li>당사 개발 건강관리 소프트웨어(이하 "스마트건강코치앱-SW")</li>
                            <li>태블릿 단말기/혈압계/혈당계/체중계 (외부 제조사 제품)</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>단순변심에 의한 환불 및 반품</h2>
                        <p>• 소비자는 제품 수령일로부터 7일 이내에 단순변심에 의한 반품 및 환불을 요청할 수 있습니다.</p>
                        <p>• 단, 다음의 경우에는 반품이 제한될 수 있습니다:</p>
                        <ul>
                            <li>a. 소프트웨어 설치 및 활성화(시리얼번호 입력 등)가 완료된 경우</li>
                            <li>b. 태블릿 및 의료기기의 포장이 훼손되거나 사용 흔적이 있는 경우</li>
                            <li>c. 소비자의 귀책사유로 제품이 훼손 또는 멸실된 경우</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>제품 이상/불량에 의한 환불 및 교환</h2>
                        <p>• 구성품 중 의료기기 또는 태블릿에 제조상 불량이 있는 경우, 각 제조사의 A/S 또는 교환/환불 정책에 따라 처리됩니다.</p>
                        <p>• 당사 SW의 기능상 오류 또는 기술적 문제 발생 시, 문제 해결을 위한 기술지원이 우선 제공되며, 해소되지 않을 경우 부분 환불 또는 전액 환불이 가능합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>환불 처리 절차</h2>
                        <p>• 환불 신청은 당사 고객센터(070-4348-0881) 또는 이메일(smarthealthcitylab@shcl.co.kr)로 접수하셔야 하며, 승인 후 반품 주소 및 절차가 안내됩니다.</p>
                        <p>• 환불은 제품 회수 및 상태 확인 후 7영업일 이내에 결제 수단으로 반환됩니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>비용 부담</h2>
                        <p>• 단순변심에 의한 반품 시 왕복 배송비는 소비자 부담입니다.</p>
                        <p>• 제품 이상/불량에 따른 반품의 경우 왕복 배송비는 당사 부담입니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>부분 환불 기준</h2>
                        <p>• SW는 디지털 콘텐츠로서 이용 또는 다운로드가 시작된 경우 환불이 제한됩니다.</p>
                        <p>• 구성품 중 일부(예: 의료기기만 반품 등)의 반품은 원칙적으로 불가하나, 사유에 따라 부분 환불이 적용될 수 있으며, 이 경우 SW 사용료, 태블릿 감가상각, 의료기기 정가 등을 기준으로 정산됩니다.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy; 